import { AlertTriangle } from 'lucide-react';
import { TableScroll } from './TableScroll';

export function RisksMatrix({ risks }) {
  return (
    <section id="riscos" className="acq-section">
      <div className="acq-container">
        <header>
          <span className="kicker">Riscos e mitigação</span>
          <h2>Riscos identificados e como são tratados.</h2>
        </header>
        <div className="body">
          <TableScroll>
          <table className="data-table" data-testid="risks-table">
            <thead>
              <tr>
                <th style={{ width: '35%' }}>Risco</th>
                <th>Mitigação</th>
              </tr>
            </thead>
            <tbody>
              {(risks || []).map((r) => (
                <tr key={r.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
                      <AlertTriangle size={14} className="text-amber-700" />
                      {r.label}
                    </div>
                  </td>
                  <td style={{ color: 'var(--muted)' }}>{r.mitigation}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </TableScroll>
        </div>
      </div>
    </section>
  );
}
